
import 'react-image-lightbox/style.css';
import "./pdi-style.css";
import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Card, Row, Col, message, Empty, Descriptions, Tabs } from "antd";
import axios from "services/axios";
import moment from "moment";
import momentTZ from "moment-timezone";
import { getValue, getCarBrand, getCarModel, getCarType } from "../utils";
import PhotoDocument from "./PhotoComponent/PhotoDocument";
import Lightbox from 'react-image-lightbox';

const httpFromHttps = url => url.replace('http://', 'https://');

const TabPane = Tabs.TabPane;

class OfferingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carInspection: {},
      appraisal: {},
      photo: {},
      showModalImage: false,
      disableForm: false,
      imageStyle: {backgroundImage: '', backgroundPosition: '0% 0%'}
    }

    this.setPhotoModalVisible = this.setPhotoModalVisible.bind(this);
  }

  componentDidMount = async () => {
    try {
      let { id } = this.props.match.params;
      let req = await axios.get(`/pdi/${id}/compare`);
      this.setState({...req.data});
    } catch (err) {
      console.error(err);
      message.error("Error, Can't fetch PDI detail");
    }
  };

  setPhotoModalVisible = (key, photo = {}) => {
    this.setState({
      showModalImage: key,
      photo,
      imageStyle: {...this.state.imageStyle, backgroundImage: key ?`url(${httpFromHttps(photo.imageUrl)})` : ''  }
    });
  }

  DescriptionComponent(title, section, values ) {
    return(
      <React.Fragment>
        <Descriptions size="small" title={title} column={1} bordered={true} className="magin-top">
          {values.map((field, index) => 
          {
            return getObj(section, field).fieldName === "Warna Eksterior" 
            ? (
              <Descriptions.Item key={index} label={getObj(section, field).fieldName}>
                {getValue(section.carSummary, "Kategori Warna") !== "" 
                ? getValue(section.carSummary, "Kategori Warna")
                : getObj(section, field).value}
              </Descriptions.Item>
            )
            : getObj(section, field).fieldName === "Brand"
            ? (
              <Descriptions.Item key={index} label={getObj(section, field).fieldName}>
                {getObj(section, field).fieldName === "Brand" !== "" 
                ? getCarBrand(this.props.Car, getObj(section, field).value)
                : getObj(section, field).value}
              </Descriptions.Item>
            )
            : getObj(section, field).fieldName === "Model"
            ? (
              <Descriptions.Item key={index} label={getObj(section, field).fieldName}>
                {getObj(section, field).fieldName === "Model" !== "" 
                ? getCarModel(this.props.Car, getObj(section, field).value)
                : getObj(section, field).value}
              </Descriptions.Item>
            )
            : getObj(section, field).fieldName === "Tipe"
            ? (
              <Descriptions.Item key={index} label={getObj(section, field).fieldName}>
                {getObj(section, field).fieldName === "Tipe" !== "" 
                ? getCarType(this.props.Car, getObj(section, field).value)
                : getObj(section, field).value}
              </Descriptions.Item>
            )
            : (
              <Descriptions.Item key={index} label={getObj(section, field).fieldName}>
                {getObj(section, field).value}
              </Descriptions.Item>
            )
          }
          )}
        </Descriptions>
        {section.notes && title === "Car Information" ? (
          <Descriptions layout="vertical" bordered>
            <Descriptions.Item label="Notes">{section.notes}</Descriptions.Item>
          </Descriptions>
        ) : null}
      </React.Fragment>
    )
  }

  SalesDescription() {
    const { appraisal, supervisor, manager, salesBranch } = this.state;
    return (
      <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
        <Descriptions.Item label="Nama Sales">  {getObj(appraisal.Booking, "SalesProfile.name")} </Descriptions.Item>
        <Descriptions.Item label="Nama Cabang"> {salesBranch? salesBranch.partnerName : getObj(appraisal.Booking, "SalesProfile.branch")} </Descriptions.Item>
        <Descriptions.Item label="No. Hp"> {getObj(appraisal.Booking, "SalesProfile.phone")} </Descriptions.Item>
        <Descriptions.Item label="Nama SS"> {supervisor ? supervisor.name: ""} </Descriptions.Item>
        <Descriptions.Item label="Nama Kacab"> {manager ? manager.name: ""} </Descriptions.Item>
      </Descriptions>
    )
  }

  Gallery(section) {
    return (
      <Tabs defaultActiveKey="1" onChange={this.onChangeTabs}>
        <TabPane forceRender={true} tab="Photo" key="1">
          <div id="photo-doc-print">
            <PhotoDocument
              photos={section.photoDocument}
              appraisalId={section.id}
              photoModal={this.setPhotoModalVisible}
            />
          </div>
        </TabPane>
        <TabPane forceRender={true} tab="Frame" key="2">
          <div id="photo-frame-print">
            <PhotoDocument
              photos={section.photoFrame}
              appraisalId={section.id}
              photoModal={this.setPhotoModalVisible}
            />
          </div>
        </TabPane>
        <TabPane forceRender={true} tab="System Engine" key="3">
          <div id="photo-engine-print">
            <PhotoDocument
              photos={section.photoEngine}
              appraisalId={section.id}
              photoModal={this.setPhotoModalVisible}
            />
          </div>
        </TabPane>
        <TabPane forceRender={true} tab="Interior" key="4">
          <div id="photo-interior-print">
            <PhotoDocument
              photos={section.photoInterior}
              appraisalId={section.id}
              photoModal={this.setPhotoModalVisible}
            />
          </div>
        </TabPane>
        <TabPane forceRender={true} tab="Exterior" key="5">
          <div id="photo-exterior-print">
            <PhotoDocument
              photos={section.photoExterior}
              appraisalId={section.id}
              photoModal={this.setPhotoModalVisible}
            />
          </div>
        </TabPane>
      </Tabs>
    )
  }

  render() {
    const { appraisal, carInspection } = this.state;
    return carInspection.id ? (
      <Card>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            {this.SalesDescription()}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Card title="PDI">
              <Descriptions size="small" title="PDI Informartion" column={1} bordered={true}>
                <Descriptions.Item label="Tanggal Assign PDI">
                    {carInspection.misc.assignTime ? momentTZ(carInspection.misc.assignTime).tz("asia/Jakarta").format("dddd, D MMMM YYYY HH:mm") : ""}
                </Descriptions.Item>
                <Descriptions.Item label="Inspector PDI"> {carInspection.Inspector ? carInspection.Inspector.name : ""} </Descriptions.Item>
              </Descriptions>
              {this.DescriptionComponent("Customer Information", carInspection, [
                "carDetail[0]",
                "carDetail[1]",
                "carDetail[2]",
              ])}
              {this.DescriptionComponent("Car Information", carInspection, [
                "carDetail[7]",
                "carSummary[0]",
                "carSummary[1]",
                "carSummary[2]",
                "carSummary[3]",
                "carDetail[6]",
                "carDetail[8]",
                "carDetail[9]",
                "carDetail[10]",
                "carDetail[11]", 
                "carDetail[12]", 
                "carDetail[13]"
              ])}
              {this.Gallery(carInspection)}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card title="APPRAISAL">
              <Descriptions size="small" title="Appraisal Informartion" column={1} bordered={true}>
                <Descriptions.Item label="Tanggal Appraisal">
                    {moment(getObj(appraisal, "Booking.bookingTime")).format("dddd, D MMMM YYYY")} {moment(getObj(appraisal, "Booking.bookingTime")).format("HH : mm")}
                </Descriptions.Item>
                <Descriptions.Item label="Nama Appraiser"> {getObj(appraisal, "Booking.Appraiser.name")} </Descriptions.Item>
              </Descriptions>
              {this.DescriptionComponent("Customer Information", carInspection, [
                "carDetail[0]",
                "carDetail[1]",
                "carDetail[2]",
              ])}
              {this.DescriptionComponent("Car Information", appraisal, [
                "carDetail[7]",
                "carSummary[0]",
                "carSummary[1]",
                "carSummary[2]",
                "carSummary[3]",
                "carDetail[6]",
                "carDetail[8]",
                "carDetail[9]",
                "carDetail[10]",
                "carDetail[11]", 
                "carDetail[12]", 
                "carDetail[13]"
              ])}
              {this.Gallery(appraisal)}
            </Card>
          </Col>
        </Row>
        {this.state.showModalImage && (
          <Lightbox
            mainSrc={this.state.photo.imageUrl}
            onCloseRequest={() => this.setPhotoModalVisible(false)}
          />
        )}
      </Card>
    ) : (<Empty/>) ;
  }
}

const FormOffering = Form.create()(OfferingDetail);
const mapStateToProps = ({ Auth, Car }) => ({ Auth, Car });

export default connect(mapStateToProps)(FormOffering);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/PDI/PDIDetail.js